"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listAuditLog = exports.listAudit = void 0;
const ApiClient_1 = require("../ApiClient");
const listAudit = (subjectType, subjectId) => {
    const params = new URLSearchParams({ subjectType, subjectId });
    return ApiClient_1.apiClient.get(`/api/audit?${params.toString()}`);
};
exports.listAudit = listAudit;
const listAuditLog = (filters) => {
    const params = new URLSearchParams();
    if (filters.page)
        params.set('page', String(filters.page));
    const query = params.toString();
    return ApiClient_1.apiClient.get(`/api/audit${query ? `?${query}` : ''}`);
};
exports.listAuditLog = listAuditLog;
